import appSettings from 'wanderu-config';
import {
    fetchTripAction,
} from 'wanderu-ducks-trips';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import {
    ROUTED_TRIP_DELIMITER,
} from '../../../constants';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-search:fetchTrip');

function fetchTrip(tripId) {
    return async function(dispatch, getState) {
        dispatch(actions.startWork(tripId));

        const ids = tripId.split(ROUTED_TRIP_DELIMITER);
        let error;
        await Promise.all(ids.map(async (id) => {
            try {
                await dispatch(fetchTripAction.fetchTrip(id));

                const error = fetchTripAction.selectError(getState(), id);

                if (error) {
                    throw error;
                }
            } catch (ex) {
                const domainUserInfo = appSettings.env.isClient
                    ? SnowplowService.getDomainUserInfo()
                    : {};

                logger.error('fetchTrip', ex, {
                    snowplowIds: {
                        networkUserId: SnowplowService.getNetworkUserId(),
                        ...domainUserInfo,
                    },
                });

                error = {
                    code: ex.code,
                    message: ex.message,
                    name: ex.name,
                };
            }
        }));
        dispatch(actions.endWork(tripId, undefined, error));
    };
}

const fetchTripsAction = {
    fetchTrip,
    ...selectors,
};

export {
    fetchTripsAction,
};

export default {
    [namespace]: reducer,
};
